import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { cookieStorage, createStorage, http } from '@wagmi/core';
import { defineChain, sepolia, mainnet } from '@reown/appkit/networks';
import { AppConfig } from './app-config';
import { REACT_APP_OPENZK_RPC } from './Config.js';
import { createAppKit } from '@reown/appkit/react';
import walletsToExclude from './excludeWallets.json';

const openZkNetwork = defineChain({
  id: 4681,
  name: 'OpenZK Testnet',
  caipNetworkId: 'eip155:4681',
  chainNamespace: 'eip155',
  nativeCurrency: {
    name: 'OpenZK Testnet',
    symbol: 'OZK',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://openzk-testnet.rpc.caldera.xyz/http'],
    },
  },
  blockExplorers: {
    default: {
      name: 'OpenZK Testnet',
      url: 'https://openzk-testnet-eth.explorer.caldera.xyz/',
      apiUrl: 'https://openzk-testnet.explorer.caldera.xyz/api',
    },
  },
});

const openZkMainnetNetwork = defineChain({
  id: 1345,
  name: 'OpenZK',
  caipNetworkId: 'eip155:1345',
  chainNamespace: 'eip155',
  nativeCurrency: {
    name: 'OpenZK',
    symbol: 'ozETH',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [REACT_APP_OPENZK_RPC],
    },
  },
  blockExplorers: {
    default: {
      name: 'OpenZK',
      url: 'https://explorer.openzk.net/',
      apiUrl: 'https://explorer.openzk.net/api',
    },
  },
});

const openZkTransport = http('https://openzk-testnet.rpc.caldera.xyz/http');
const openZkMainnetTransport = http(REACT_APP_OPENZK_RPC);
const sepoliaTransport = http(
  'https://eth-sepolia.g.alchemy.com/v2/PQae1A79paBU9liPS1kdZ61HS5O5KJUd',
);
const mainnetTransport = http(
  'https://eth-mainnet.g.alchemy.com/v2/ikiqikM7uHSREHr8SWuedwKSYs5f-tC0',
);

const metadata = {
  name: 'openzk',
  description: 'Web3Modal Example',
  url: AppConfig.appUrl, // origin must match your domain & subdomain
  icons: ['https://avatars.githubusercontent.com/u/37784886'],
};

export const Networks = {
  sepolia,
  openzk: openZkNetwork,
};

export const MainnetNetworks = {
  mainnet,
  openzk: openZkMainnetNetwork,
};

const networks = AppConfig.isDev
  ? [sepolia, openZkNetwork]
  : [mainnet, openZkMainnetNetwork];

const transports = AppConfig.isDev
  ? {
      [sepolia.id]: sepoliaTransport,
      [openZkNetwork.id]: openZkTransport,
    }
  : {
      [mainnet.id]: mainnetTransport,
      [openZkMainnetNetwork.id]: openZkMainnetTransport,
    };

export const wagmiAdapter = new WagmiAdapter({
  projectId: AppConfig.reown.projectId,
  networks: networks,
  storage: createStorage({
    storage: cookieStorage,
  }),
  transports: transports,
});

createAppKit({
  metadata,
  projectId: AppConfig.reown.projectId,
  networks: AppConfig.isDev
    ? [Networks.sepolia, Networks.openzk]
    : [MainnetNetworks.mainnet, MainnetNetworks.openzk],
  adapters: [wagmiAdapter],
  defaultNetwork: AppConfig.isDev ? Networks.sepolia : MainnetNetworks.mainnet,
  features: {
    email: false,
    socials: [],
  },
  includeWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709',
    '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662',
    '21c3a371f72f0057186082edb2ddd43566f7e908508ac3e85373c6d1966ed614',
    '20459438007b75f4f4acb98bf29aa3b800550309646d375da5fd4aac6c2a2c66',
  ],
  excludeWalletIds: walletsToExclude.map((wallet) => wallet.id),
});

export const wagmiAdapterConfig = wagmiAdapter.wagmiConfig;
